import { Component, Input } from "@angular/core";

@Component({
    selector: 'dialog-toast',
  templateUrl: './dialog-toast-notification.component.html',
  styleUrls: ['./dialog-toast-notification.component.scss']
})
export class DialogToastNotificationComponent{
    @Input() toastMessage: string | undefined;
    @Input() toastState: string = '';
    @Input() toastClass: boolean = false;

  public getImageForToast() {
    let value = this.toastState == 'success-toast' ? '../../../assets/icons/icon-done.svg' : this.toastState == 'warning-toast' ? '../../../assets/icons/icon-warning.svg' : this.toastState == 'rejected-toast' ? '../../../assets/icons/icon-rejected.svg' : this.toastState == 'caution-toast' ? '../../../assets/icons/icon-caution.svg' : this.toastState == 'information-toast' ? '../../../assets/icons/icon-information.svg' : '';
    return value;
  }

}